<template>
	<div class="modal-card change_pass_card">
		<header class="modal-card-head has-background-white">
			<h3 class="modal-card-title has-text-centered">
				<span>
					Cambiar la clave del usuario seleccionado
				</span>
			</h3>
			<button class="delete" aria-label="Cerrar Modal" @click="$emit('close')"></button>
		</header>
		<section class="modal-card-body change_pass_body">
			<div class="users_nav" role="navigation" aria-label="main navigation">
				<div class="users_pills">
					<a class="user_pill" :class="{
						'is-selected': selectedUser && selectedUser.user_id == user.user_id
					}" @click="() => selectUser(user)" v-for="user in allUsers" v-bind:key="user.user_id">
						{{ user.user_email }}
					</a>
				</div>
			</div>
			<div class="columns">
				<div class="column is-6">
					<InputWithValidation id="username" name="username" label="Usuario:" v-model="username"
						rules="email|required" :disabled="selectedUser == null" />
				</div>
			</div>

			<ValidationObserver>
				<div class="columns">
					<div class="column is-6">
						<InputWithValidation id="password" name="password" label="Contraseña:" v-model="password"
							rules="required" vid="password" type="password" :disabled="selectedUser == null" />
					</div>
					<div class="column is-6">
						<InputWithValidation id="repeatPassword" name="repeatPassword" label="Repite la contraseña:"
							rules="confirmed:password|required" v-model="repeatPassword" type="password"
							:disabled="selectedUser == null" />
					</div>
				</div>
			</ValidationObserver>

		</section>
		<footer class="modal-card-foot bt-none has-background-white is-justify-content-flex-end">
			<button class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
				Volver
			</button>
			<button class="button is-primary" :disabled="loading || disableUpdateBtn" role="button"
				@click="updateUser()">
				Grabar
			</button>
		</footer>
	</div>
</template>

<script>
import { updateUserPassword } from "@/api/security";
import InputWithValidation from "@/components/inputs/InputWithValidation";
import { consoleHandlerError, notificate } from "@/utils/message";
import { ValidationObserver } from "vee-validate";
export default {
	name: "ChangeUsernamePass",
	data() {
		return {
			loading: false,
			selectedUser: null,
			username: "",
			password: "",
			repeatPassword: "",
		};
	},
	components: {
		InputWithValidation,
		ValidationObserver
	},
	methods: {
		selectUser(user) {
			this.selectedUser = user
			this.username = user.user_email
		},
		updateUser() {
			const reqUserOps = {
				user_id: this.selectedUser.user_id,
				username: this.username,
				password: this.password,
			}
			updateUserPassword(reqUserOps).then(() => {
				notificate(
					`<strong>Éxito!</strong><br>
					Se actualizaron las credenciales`,
					"is-success is-light"
				);
			}).catch(error => {
				const customDefaultMessage = `<strong>Error!</strong><br>
					Sus credenciales no pueden estar vacias o usted no es superusuario`
				consoleHandlerError({ error, empty: true, customDefaultMessage });
			}).finally(() => {
				this.$emit("close");
			})
		}
	},
	computed: {
		disableUpdateBtn() {
			const invalidPass = this.password != this.repeatPassword || this.password == ""
			const invalidData = this.password == "" || this.username == ""
			return invalidData || invalidPass
		}
	},
	props: ["allUsers"],
	created() {
	},
};
</script>
<style scoped lang="scss">
// Tema del analista (var(--ap-*), elements/_analyst_theme.scss).
.change_pass_card {
	font-family: var(--ap-font);
	color: var(--ap-ink-2);
	width: min(680px, 94vw);
	display: flex;
	flex-direction: column;
	max-height: 86vh;
	background-color: var(--ap-paper);
	border-radius: var(--ap-radius);
	overflow: hidden;
}

::v-deep .modal-card-title {
	font-family: var(--ap-font);
	font-weight: 700;
	font-size: 20px;
	letter-spacing: -0.01em;
	color: var(--ap-ink);
}

.modal-card-head {
	border-bottom: 1px solid var(--ap-line);
}

.change_pass_body {
	background-color: var(--ap-paper);
	color: var(--ap-ink-2);
}

.users_nav {
	background-color: var(--ap-paper);
}

.users_pills {
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-bottom: 18px;
}

.user_pill {
	display: inline-flex;
	align-items: center;
	padding: 7px 14px;
	border: 1px solid var(--ap-line-strong);
	border-radius: var(--ap-radius-pill);
	background-color: var(--ap-mist);
	color: var(--ap-slate);
	font-family: var(--ap-font);
	font-size: 13px;
	font-weight: 500;
	cursor: pointer;
	transition: background-color 0.14s var(--ap-ease),
		color 0.14s var(--ap-ease), border-color 0.14s var(--ap-ease);

	&:hover {
		border-color: var(--ap-teal);
		color: var(--ap-teal-deep);
	}

	&.is-selected {
		background-color: var(--ap-ink);
		border-color: transparent;
		color: var(--ap-paper);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}
}

// Chrome del input (Buefy .input dentro de InputWithValidation compartido).
::v-deep .input {
	border: 1px solid var(--ap-line-strong);
	border-radius: var(--ap-radius-sm);
	color: var(--ap-ink);
	box-shadow: none;
	transition: border-color 0.14s var(--ap-ease), box-shadow 0.14s var(--ap-ease);

	&:focus,
	&:focus-visible {
		border-color: var(--ap-teal);
		box-shadow: 0 0 0 3px var(--ap-teal-wash);
	}
}

::v-deep .label {
	color: var(--ap-slate);
	font-weight: 600;
	font-size: 13px;
}

::v-deep .modal-card-foot {
	border-top: 1px solid var(--ap-line);

	.button.is-primary {
		background-color: var(--ap-ink);
		border-color: transparent;
		font-weight: 600;

		&:hover {
			background-color: var(--ap-teal-deep);
		}

		&:focus-visible {
			outline: 2px solid var(--ap-teal);
			outline-offset: 2px;
		}
	}
}
</style>